@import '../../../theme.scss';

verdocs-quick-functions {
  font-family: $verdocs-primary-font;

  .container {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    width: 240px;
    background-color: $verdocs-bg-5;
    text-transform: uppercase;
    padding: 10px 10px 20px 10px;
    font-family: sans-serif;
    color: #ffffff;
  }

  .title {
    font-size: 22px;
    font-weight: 700;
    line-height: 30px;
    margin: 1em 0 40px 0;
  }

  button {
    width: 140px;
    height: 40px;
    border: none;
    display: flex;
    color: $verdocs-grey-4;
    cursor: pointer;
    font-size: 14px;
    font-weight: 700;
    line-height: 25px;
    align-items: center;
    margin-bottom: 20px;
    border-radius: 5px;
    text-transform: uppercase;
    justify-content: space-evenly;
    background-color: $verdocs-green;
  }

  button svg {
    fill: $verdocs-grey-4;
  }
}
